
























export default {
  name: 'AddToPlaylistModal',
  props: {
    playlists: {
      type: Array,
    },
    mediaItemsSelected: {
      type: Array,
    },
    confirm: null,
  },
  data() {
    return {
      inProgress: false,
      playlist: {
        id: null,
        playlist_name: null,
        content: [],
      },
      selectedPlaylist: {},
    };
  },
  computed: {
    title() {
      if (this.selectedPlaylist.content) {
        return `${this.$t('PRODUCTS.TITLE.ADD_TO_PLAYLIST')}
					(${this.selectedPlaylist.content.length}
					${this.$tc(
            'PRODUCTS.TEXT.ITEMS_VARIANT',
            this.selectedPlaylist.content.length
          )})`;
      }
      return this.$t('PRODUCTS.TITLE.ADD_TO_PLAYLIST');
    },
  },
  methods: {
    async submit() {
      try {
        this.inProgress = true;

        await this.confirm(this.selectedPlaylist);
        this.$emit('close');
      } finally {
        this.inProgress = false;
      }
    },
    onPlaylistSelect(playlist) {
      this.selectedPlaylist = playlist;
    },
  },
};
